// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
//
// The Build-mode flag (M13-09).
//
// `VITE_PINBALL_BUILD_MODE=1` puts the Build row on the wrist menu and lets `XRRuntime` enter
// the mode (`true` does too, in any case, with the whitespace trimmed — the reading
// `newRegistrationAllowed` uses); anything else — unset, `yes`, `0` — leaves the product exactly as
// it was before M13. **Closed unless it says otherwise**, the `VITE_PINBALL_ALLOW_NEW_REGISTRATION`
// rule: a gate whose failure mode is *offering* an unfinished mode to every headset fails closed.
//
// Build-time, like every `VITE_PINBALL_*` value: Vite substitutes it at `npm run build`, so a
// deployment that never sets it carries the strings and none of the behaviour. `vite.config.ts`'s
// `envPrefix` is what makes the bare `VITE_` spelling inert (see `emailOverride.ts`).
//
// Read at the point of use rather than captured at module load, for `session.ts`'s reason: a test
// stubs the environment, and a value read before the stub would be the wrong answer for ever.

export const BUILD_MODE_VAR = 'VITE_PINBALL_BUILD_MODE'

/** The two spellings that open it. Anything else is closed. */
const ON_VALUES: readonly string[] = ['1', 'true']

/** Is Build mode offered in this build? */
export function buildModeOffered(): boolean {
  const raw = (import.meta.env as unknown as Record<string, unknown>)[BUILD_MODE_VAR]
  return typeof raw === 'string' && ON_VALUES.includes(raw.trim().toLowerCase())
}
